// モジュール読み込み
// ============================================================

//import Vue from 'vue';
import * as func from './functions/_function';                        //関数関係
import * as animation from './functions/_animation';                  //アニメーション関係
import * as bliderBox from './functions/_bliderBox'                   //ブラインダーボックス
//import * as offcanvas from './functions/_offcanvas';                  //オフキャンバス
//import * as pagetop from './functions/_pagetop';                      //ページトップ
import * as loading from './functions/_loading';                      //ローディング
//import * as smoothScroll from './functions/_smoothScroll';            //スムーススクロール
//import Modal from '../../node_modules/bootstrap/js/dist/modal';       //モーダルライブラリ
import 'mobile-detect';                                               //デバイス判定・ブラウザ判定ライブラリ
import * as checkUA from './functions/_checkUA';                      //デバイス判定・ブラウザ判定処理

// 定数
// ============================================================

const BLAKEPOINT_HEADER_SP_MODE     = 1024;                               //ヘッダーレスポンシブブレイクポイント
const DEBUG_MODE                    = false;                              //デバッグモード

// グローバル変数
// ============================================================

let CURRENT_SCROLL_POS = 0;
let WIN_WIDTH                       = window.innerWidth;
let WIN_HEIGHT                      = window.innerHeight;
let CURRENT_SC_OFFSET_X             = window.pageXOffset;
let CURRENT_SC_OFFSET_Y             = window.pageYOffset;
let ACTIVE_CLASS_NAME               = 'js_isActive';
let ACCTIVE_BODYFIXED_CLASS_NAME    = 'js_isFixed';
let SCROLLDOWN_FLAG                 = true;
let PRE_SCROLL_POSITION_Y           = '';
const $SCREEN                       = {
                                      'LG' : 1280,
                                      'SM' : 414
                                      }

// サイト共通関数初期化
// ============================================================

animation.scrollObserver();                                            // アニメーション処理
checkUA.addUAClass();                                                  // UAおよびデバイスクラス追加処理
//smoothScroll.setSmoothScroll();                                        // スムーススクロール
bliderBox.setBliderBox();                                              // ブラインダーボックス初期化
//offcanvas.setOffcanvas(BLAKEPOINT_HEADER_SP_MODE,'app');               // オフキャンバス処理

// イベント毎のサイト共通関数初期化
// ============================================================

window.addEventListener('scroll', () => {
  CURRENT_SC_OFFSET_X = window.pageXOffset;
  CURRENT_SC_OFFSET_Y = window.pageYOffset;

  //引数：固定,固定,ボタンを出現させるきっかけとなる要素のID名,ボタンを固定させるきっかけとなる要素のID名
  //pagetop.setScrolltopBtn(WIN_HEIGHT,CURRENT_SC_OFFSET_Y,'mv','footer');

})

window.addEventListener('resize', () => {
  WIN_WIDTH = window.innerWidth;
  WIN_HEIGHT = window.innerHeight;
  setHeaerOffset();
})

window.addEventListener('load',() => {
  setNewsBoard();
  setCalenderBoard();
  setOffcanvas();
  setHeaerOffset();
  pageHomeScript();
  loading.initLoading(DEBUG_MODE);
})

// サイト共通関数
// ============================================================

// newsBoardの表示・非表示切り替え
function setNewsBoard(){

  let $target = $('.js_newsBoard');
  let ACTIVE_CLASS_NAME = 'js_isActive';

  let $bgLayer = $('#js_floatingUi_bgLayer');

  $('.js_newsBoard_trigger').on('click',function(){
    if($target.hasClass(ACTIVE_CLASS_NAME)){
      $target.fadeOut(ACTIVE_CLASS_NAME).removeClass(ACTIVE_CLASS_NAME);
      $bgLayer.removeClass('js_isActive');
    }else{
      $target.fadeIn(ACTIVE_CLASS_NAME).addClass(ACTIVE_CLASS_NAME);
      $bgLayer.addClass('js_isActive');
    }
  });

  $('.js_newsBoard_close').on('click',function(){
    if($target.hasClass(ACTIVE_CLASS_NAME)){
      $target.fadeOut(ACTIVE_CLASS_NAME).removeClass(ACTIVE_CLASS_NAME);
      $bgLayer.removeClass('js_isActive');
    }
  });

  $('#js_floatingUi_bgLayer').on('click',function (){
    if($target.hasClass(ACTIVE_CLASS_NAME)){
      $target.fadeOut(ACTIVE_CLASS_NAME).removeClass(ACTIVE_CLASS_NAME);
      $(this).removeClass('js_isActive');
    }
  });
}

// オフキャンバス時背景固定
function toggleBodyFixed(toggle){

  let $wrapper = $('.wrapper');
  let $body = $('body');

  let scrollTop = CURRENT_SC_OFFSET_Y;

  if(toggle){
    PRE_SCROLL_POSITION_Y = scrollTop;
    $wrapper.css({
      position: 'fixed',
      top: -1 * scrollTop,
      left:0,
      right:0
    });
    console.log('TRUE : scrollTop is ' + scrollTop);
  }else{
    $wrapper.css({
      position: '',
      top: '',
      left:'',
      right:''
    });
    console.log('FALSE : scrollTop is ' + scrollTop);
    $(window).scrollTop(PRE_SCROLL_POSITION_Y);
  }

}


// オフキャンバス
// ------------------------------------------------------------

function setOffcanvas(){

  let active_class_name = 'js_offcanvasShown';
  let $trigger = $('.js_offcanvas_trigger');
  let $closeTrigger = $('.js_offcanvas_closeTrigger');
  let $body = $('body');

  $trigger.on('click',function (){

    let targetId = '#' + $(this).data('target');
    let $targetElm = $(targetId);

    if(!($targetElm.hasClass(active_class_name))){
      $targetElm.addClass(active_class_name);
      $body.addClass(ACCTIVE_BODYFIXED_CLASS_NAME + ' js_offcanvasActive');
      toggleBodyFixed(true);

    }else{
      $targetElm.removeClass(active_class_name);
      $body.removeClass(ACCTIVE_BODYFIXED_CLASS_NAME  + ' js_offcanvasActive');
      toggleBodyFixed(false);
    }

  })

  $closeTrigger.on('click',function (){
    let $closerTargetElm = $body.find('.' + active_class_name);
    $closerTargetElm.removeClass(active_class_name)
    $body.removeClass(ACCTIVE_BODYFIXED_CLASS_NAME + ' js_offcanvasActive');
    toggleBodyFixed(false);
  })



}

// トップページ固有処理
// ============================================================

function pageHomeScript() {
  if ($('.top').length) {
    setMvHeight();
  }
}

// メインビジュアルの高さ保持
// ------------------------------------------------------------

function setMvHeight(){

  let $header = $('#header');
  let headerH = $header.height() + ($header.css('margin-bottom'), 10);
  let mvH;

  function checkRatio(self_mvH){
    if(self_mvH / WIN_WIDTH > 0.35){
      return self_mvH;
    }else if(WIN_HEIGHT < $SCREEN.SM){
      let transRatio = WIN_WIDTH / 2;
      return transRatio;
    }else{
      let transRatio = WIN_WIDTH / 2;
      return transRatio;
    }
  }

  if($('body').hasClass('isSP')){

    let gnavSpBodyH = $('.gnav_sp_body').outerHeight();
    let self_mvH = WIN_HEIGHT - headerH - gnavSpBodyH;
    $('#mv').height(checkRatio(self_mvH));

  }else{

    let self_mvH = WIN_HEIGHT - headerH;
    $('#mv').height(checkRatio(self_mvH));

  }
}

// ラッパーコンテナオフセット処理
// ------------------------------------------------------------

function setHeaerOffset(){

  const activeClassName = 'js_setHeaerOffset';

  if(WIN_WIDTH > $SCREEN.LG && !($('body').hasClass('isSP'))){
    let $header = $('#header');
    let headerH = $header.height() + ($header.css('margin-bottom'), 10);
    $('.wrapper').css('margin-top',headerH);
    $('body').addClass(activeClassName);
  }else{
    if($('body').hasClass(activeClassName)){
      $('body').removeClass(activeClassName)
      $('.wrapper').css('margin-top',0);
    }
  }

}

// calendarBoardスライド処理
// ------------------------------------------------------------

function setCalenderBoard(){

  let $calendarBoard = $('.js_calendarBoard');
  let $bgLayer = $('#js_floatingUi_bgLayer');

  $('.js_calendarBoard_trigger').on('click',function (){

    if($calendarBoard.hasClass('js_isActive')){
      $calendarBoard.removeClass('js_isActive');
      $bgLayer.removeClass('js_isActive');
    }else{
      $calendarBoard.addClass('js_isActive');
      $bgLayer.addClass('js_isActive');
    }

  });

  $('#js_floatingUi_bgLayer').on('click',function (){

    if($calendarBoard.hasClass('js_isActive')){
      $calendarBoard.removeClass('js_isActive');
      $(this).removeClass('js_isActive');
    }

  });

}

// リセット処理
// -------------------

function resetCalenderBoard(){
  if($('#js_floatingUi_bgLayer').hasClass('js_isActive')){
    $('#js_floatingUi_bgLayer').removeClass('js_isActive');
  }
}



// offcanvas_menuの表示非表示
// ------------------------------------------------------------

// function setOffcanvas(){
//   $('.offcanvas_menu_trigger').on('click' , function(){
//     $('.offcanvas_menu').addClass('js_offcanvasActive');
//     $('body').addClass('js_offcanvasActive');
//     $('.offcanvas_closeUnit').on('click',function(){
//       $('.offcanvas_menu').removeClass('js_offcanvasActive');
//       $('body').removeClass('js_offcanvasActive');
//     })
//   });
// }

// 独自のクラスを追加
// ============================================================

if($('[data-classname]').length){
  $.each($('[data-classname]'), function(i, val) {
    let className = $(val).data('classname');
    $(val).addClass(className);
  });
}
